module.exports = require("@swa-ui/core/src/BackgroundVeil/BackgroundVeil.module.scss");